export default {
    issues: {
        title: "All Issues",
        subtitle: "{{count}} issue across all containers",
        subtitle_plural: "{{count}} issues across all containers",
        intro:
            "This is your operational exception queue: structured problems tied to containers or documents (missing docs, validation checks, delays, and more).",
        bulletTiles: "Summary tiles at the top filter the table by common categories (missing docs, single checks, cross-checks, other).",
        bulletFilters:
            "Use the filter bar for severity, status, category, type, search, blocking-only, resolved visibility, and date range (container ETA/ETD — see the info icon next to dates).",
        bulletTable: "Click a row to open the shipment page with the Issues tab so you can act in full context.",
        reviewContrast:
            "Human confirmation tasks (identification, document assignment) live in <reviewLink>Review Center</reviewLink> — different from this operational issues list.",
    },
    reviewCenter: {
        sidebarListTitle: "Items n. {{count}}",
        sidebarListTitleLoading: "Items",
        title: "Review Center",
        intro:
            "A short queue where the system needs a human decision before data is trusted: container identification, document assignment, tracking checks, and similar confirmations. Clearing this regularly keeps downstream automation accurate.",
        step1: "Pick a container from the list on the left (pending items are highlighted).",
        step2: "Use Identification to verify or edit fields, answer agent questions if shown, then resolve or dismiss.",
        step3: "Use Documents to keep, reclassify, remove, or move documents; merge duplicates when suggested.",
        step4: "Open emails or document previews from the detail panel when you need source context.",
        vsIssues:
            "For structured operational problems on shipments and documents, use <issuesLink>Issues</issuesLink>.",
    },
};
